// extracted by mini-css-extract-plugin
export default {"fontSize":"Item_fontSize__vdIlE","title":"Item_title__6fkZp"};